<template>
  <LoadSpinner v-if="loading" />
  <div
    v-else
    class="listing-card-grid"
  >
    <div class="listing-card-grid__grid">
      <div
        v-for="housingLocality in housingLocalities"
        class="listing-card-grid__column"
      >
        <HousingLocalityCard
          :housing-locality="housingLocality"
          class="listing-card-grid__item"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import globals from '../lib/globals';
  import LoadSpinner from './components/LoadSpinner';
  import HousingLocalityCard from './components/HousingLocalityCard';

  export default {
    components: {HousingLocalityCard, LoadSpinner},
    props: {
      // Keys should match with ACF block's props keys in blocks.php.
      group: {
        type: String,
        default: 'old',
      },
      types: {
        type: String,
        default: 'all',
      },
    },
    data() {
      return {
        loading: false,
        housingLocalities: [],
      };
    },
    async beforeMount() {
      this.loading = true;
      const url = `${globals.urlIntegrationApi}/public/housinglocalities-by-group/${this.group}/${this.types}`;
      const response = await axios.get(url);
      this.housingLocalities = response.data;
      this.loading = false;
    },
  };
</script>
